export default "__VITE_ASSET__BCv3X$iq__"